import { Box, Link, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import LoginPaper from '../../components/LoginPaper'
import { useNavigate } from 'react-router-dom'

const NewSuccessPanel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <LoginPaper>
      <Stack alignItems="center" gap={2}>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '36px',
            fontWeight: 600,
            color: 'content.secondary',
            '&::after': {
              bottom: 0,
              color: 'common.accent',
              content: '" !"',
              position: 'relative',
              transform: 'translate(-100%, 0)',
            },
          }}
        >
          {t('login.password_changed')}
        </Typography>

        <Box fontSize="48px" sx={{ color: 'common.accent' }}>
          <i className="fa-solid fa-circle-check"></i>
        </Box>

        <Stack
          gap={0.5}
          sx={{
            color: 'content.secondary',
            fontSize: '14px',
            lineHeight: '24px',
            fontWeight: 400,
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: 'inherit',
              lineHeight: 'inherit',
              fontWeight: 'inherit',
            }}
          >
            {t('login.success_new_password')}
          </Typography>
          <Typography
            sx={{
              fontSize: 'inherit',
              lineHeight: 'inherit',
              fontWeight: 'inherit',
            }}
          >
            <Link onClick={() => navigate({ pathname: '/auth/login'})}>
              {t('login.sucess_new_message')}
            </Link>
          </Typography>
        </Stack>
      </Stack>
    </LoginPaper>
  )
}

export default NewSuccessPanel
